import { render, staticRenderFns } from "./expertListData.vue?vue&type=template&id=476612f3&"
import script from "./expertListData.vue?vue&type=script&lang=js&"
export * from "./expertListData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports